import Http from '../../utils/Http';
import * as Order from '../../store/allStates/order/actions';
import { Dispatch, AnyAction } from 'redux';
import Transformer from '../../utils/Transformer';
import { admin_prefix } from '../../../configs/constant';
const { Storage } = require('../../../configs/lib');
export function getChallanList() {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}specific-order/challan-list`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}

export function getSpecificProductList(filter: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}specific-order/products`, { params: filter })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}

export function getbuyercartofspecificorder(filter?: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}specific-order/get-specific-cart`, {
                params: filter,
            })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    Storage.setItem('orderid', data.data.rows[0]._id);
                    dispatch(Order.cart(data.data.rows.length > 0 && data.data.rows[0].order_details));
                    dispatch(Order.grossAmount(data.data.rows.length > 0 && data.data.rows[0].gross_amount));
                    return resolve(data);
                })
                .catch((err) => {
                    dispatch(Order.cart([]));
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function savespecificorder(requestData: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}specific-order/save-specific-order`, requestData)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function updatespecificorder(orderId: any, requestData: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.put(`${admin_prefix}specific-order/edit-cart/${orderId}`, requestData)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function deletespecificorder(id: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.delete(`${admin_prefix}specific-order/delete-cart-items/${id}`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function getspecificcartlist(filter: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}specific-order/get-specific-cart`, {
                params: filter,
            })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function submitSpecificOrder(requestData: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}specific-order/submit-order`, requestData)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function getSpecificOrderHistory(filter: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}specific-order/order-history`, {
                params: filter,
            })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function getunpaidorderlist(id: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}specific-order/unpaid-order-history/${id}`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function getspecificorderdetails(id: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}specific-order/order-history/${id}`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function submitpaymentforspecificorder(requestedData: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}specific-order/payment-status-update`, requestedData)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function sendmailforspecificorder(requestedData: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}specific-order/send-mail`, requestedData)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function specificOrderHistoryById(id: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}specific-order/order-history-by-id/${id}`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function getspecificbuyerorderhistory(filter: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}specific-order/order-history-buyer`, {
                params: filter,
            })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function cancelspecificorder(id: any, isBuyerOrderHistory: boolean = false) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}specific-order/cancel-order/${id}`, null, {
                params: { buyer_order_history: isBuyerOrderHistory },
            })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function statuschangespecificorder(id: any, requestData: any, isBuyerOrderHistory: boolean = false) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}specific-order/status-change/${id}`, requestData, {
                params: { buyer_order_history: isBuyerOrderHistory },
            })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}
